import sanityClient from "@sanity/client";

export default sanityClient({
    projectId: "p8fne4nk",
    dataset: "production",
    useCdn: true,
    apiVersion: '2021-08-31', // use a UTC date string
})